// Wrapper ligero sobre IndexedDB para la cola de hojas de visita pendientes de envío


const DB_NAME = "laefincas-visit-queue";
const DB_VERSION = 3;
const STORE_NAME = "pending";
const SETTINGS_STORE = "settings";
const DRAFTS_STORE = "drafts";

let dbPromise = null;

const openDB = () => {
  if (dbPromise) return dbPromise;

  dbPromise = new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("IndexedDB no está disponible en este navegador"));
      return;
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
      if (!db.objectStoreNames.contains(SETTINGS_STORE)) {
        db.createObjectStore(SETTINGS_STORE, { keyPath: "key" });
      }
      if (!db.objectStoreNames.contains(DRAFTS_STORE)) {
        db.createObjectStore(DRAFTS_STORE, { keyPath: "id" });
      }
    };

    request.onsuccess = (event) => resolve(event.target.result);
    request.onerror = () => reject(request.error);
  });

  return dbPromise;
};

const runTransaction = async (storeName, mode, operation) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, mode);
    const store = tx.objectStore(storeName);
    let result;
    try {
      result = operation(store);
    } catch (err) {
      reject(err);
      return;
    }
    tx.oncomplete = () => resolve(result instanceof IDBRequest ? result.result : result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
};

// Inserta o reemplaza una entrada (keyPath = id). Reenviar la misma visita sobrescribe la entrada anterior.
export const putEntry = (entry) =>
  runTransaction(STORE_NAME, "readwrite", (store) => store.put(entry));

export const getAllEntries = () =>
  runTransaction(STORE_NAME, "readonly", (store) => store.getAll());

export const getEntry = (id) =>
  runTransaction(STORE_NAME, "readonly", (store) => store.get(id));

export const deleteEntry = (id) =>
  runTransaction(STORE_NAME, "readwrite", (store) => store.delete(id));

export const countEntries = () =>
  runTransaction(STORE_NAME, "readonly", (store) => store.count());

// Ajustes de la cola (persistentes)
export const getSetting = async (key) => {
  const record = await runTransaction(SETTINGS_STORE, "readonly", (store) =>
    store.get(key)
  );
  return record ? record.value : undefined;
};

export const setSetting = (key, value) =>
  runTransaction(SETTINGS_STORE, "readwrite", (store) =>
    store.put({ key, value })
  );

// Borradores en curso
export const putDraft = (draft) =>
  runTransaction(DRAFTS_STORE, "readwrite", (store) => store.put(draft));

export const getDraft = (id) =>
  runTransaction(DRAFTS_STORE, "readonly", (store) => store.get(id));

export const getAllDrafts = () =>
  runTransaction(DRAFTS_STORE, "readonly", (store) => store.getAll());

export const deleteDraft = (id) =>
  runTransaction(DRAFTS_STORE, "readwrite", (store) => store.delete(id));
